module.exports = __webpack_public_path__ + "img/icon.7f76e0b8.png";